<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/prvdEB/tc-custom/9781504083171.jpg?1718073969684" alt="This image is the cover for the book Dark Lie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Lie
      </h1>
      <p class="bookDescription body article font2">
        <b>From an Edgar Award winner, this abduction story is “a compulsive page turner that will have readers cheering on the decidedly unglamorous heroine” (<i>Kirkus Reviews</i>).</b><br/>  <br/> Dorrie White should be content with her life. She has a steady job, a loving husband. But <br/> Dorrie also has a secret—one that has caught up with her. When she was a teenager in high school, Dorrie got pregnant and put her baby up for adoption. When she discovers her daughter, Juliet, lives nearby, she can’t help but keep tabs on the girl. But the maternal urge to be close to her child turns into every mother’s nightmare when, right before Dorrie’s eyes, Juliet is abducted at a suburban shopping mall, forced into a van that quickly drives away. Stricken, Dorrie does the only thing any mother would: she goes after her. Only to put herself at the mercy of a psychopath, sending her devoted husband on a desperate search to bring her home again. As Dorrie and Juliet struggle together to survive captivity, Dorrie is forced to confront her own dark past.<br/>  <br/> “A fast-paced, edge of your seat thriller.” —Heather Gudenkauf, <i>New York Times</i>–bestselling author of <i>The Overnight Guest</i><br/>  <br/> “A darkly riveting read . . . Compelling.” —Wendy Corsi Staub, <i>New York Times</i>–bestselling author of <i>The Other Family</i><br/>  <br/> “A truly unique and fascinating heroine.” —Alison Gaylin, <i>USA Today</i>–bestselling author of <i>And She Was</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy Springer
      </h2>
      
      <p class="authorDescription body article">Nancy Springer is the award-winning author of more than fifty books, including the Enola Holmes and Rowan Hood series and a plethora of novels for all ages, spanning fantasy, mystery, magic realism, and more. She received the James Tiptree, Jr. Award for&#160;<I>Larque on the Wing</I> and the Edgar Award for her juvenile mysteries&#160;<I>Toughing It&#160;</I>and&#160;<I>Looking for Jamie Bridger</I>,&#160;and she has been nominated for numerous other honors. Springer currently lives in the Florida Panhandle, where she rescues feral cats and enjoys the vibrant wildlife of the wetlands.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4038c157